var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIncorrect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.2488 7.27746C7.58857 6.91614 8.14889 6.90645 8.50029 7.25582L12.2 10.9341L15.8997 7.25582C16.2511 6.90645 16.8114 6.91614 17.1512 7.27745C17.491 7.63877 17.4816 8.2149 17.1302 8.56427L13.4733 12.2L17.1302 15.8357C17.4816 16.1851 17.491 16.7612 17.1512 17.1225C16.8114 17.4839 16.2511 17.4936 15.8997 17.1442L12.2 13.4659L8.50028 17.1442C8.14888 17.4936 7.58857 17.4839 7.24879 17.1225C6.90902 16.7612 6.91844 16.1851 7.26984 15.8357L10.9268 12.2L7.26984 8.56427C6.91844 8.2149 6.90902 7.63878 7.2488 7.27746Z",
    fill: "#4D4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncorrect);
export default __webpack_public_path__ + "static/media/incorrect.7211661b.svg";
export { ForwardRef as ReactComponent };